import axios from 'axios'
import vm from '../main'
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from './jsencrypt.min'
import qs from 'qs'
import Setting from '@/setting'

const util = {Setting}
// read env from configs file
const env = window['$env'] ? window['$env'] : process.env.NODE_ENV

// 根据环境变量动态设置基础URL
if (process.env.NODE_ENV === 'production') {
    util.baseUrl = process.env.VUE_APP_API_PROD_URL || 'https://meetingtrips.com/prod-api'
} else if (process.env.NODE_ENV === 'development') {
    util.baseUrl = process.env.VUE_APP_API_TEST_URL || 'http://8.159.145.54/prod-api'
} else {
    util.baseUrl = '/apiDev'
}

Setting.dataBankType = '0'

// 租户模式是否打开，true打开，false是关闭
util.sassModel = false

// 将需要外挂文件覆盖的属性写在该函数执行前
loadConfigs()

export var requestMethod = util.http = axios.create({
    baseURL: util.baseUrl,
    timeout: 60000,
    withCredentials: true
})
// http 请求拦截
util.http.interceptors.request.use(
    function (config) {
        config.headers.Authorization = "Bearer " + localStorage.token

        // 如果传入了自定义请求方式，使用传入的请求方式
        if(config.methodType){
            config.method = config.methodType
        }
        
        if(config.header){
            config.headers['Accept-Language'] = config.header
        } else {
            config.headers['Accept-Language'] = localStorage.local == 'zh' ? 'zh-CN' : 'en-US'
        }

        // 如果传入了 FormDataType，设置为 FormData 类型
        if(config.FormDataType){
            config.headers['Content-Type'] = 'multipart/form-data'
        }

        return config
    },
    function (error) {
        // 请求失败的处理
        return Promise.reject(error)
    }
)

// http响应拦截
util.http.interceptors.response.use(
    function (res) {
        // console.log("🚀 ~ res:", res.data)
        // 在这里对返回的数据进行处理
        if (!res.config.url.includes('refreshToken')) {
            // 记录ajax调用的时间
            sessionStorage.lastHttpRequestTime = +new Date()
        }
        switch (res.data.code) {
            case 401:
                vm.$Message.warning({
                    content: '您的登录已超时，请重新登录！',
                    duration: 3
                })
                vm.$router.push('/login')
                vm.$store.dispatch('dict/setToken', '')
                vm.$store.dispatch('dict/setUserInfo', {})
                window.localStorage.removeItem('token')
                window.localStorage.removeItem('userInfo')

                break
            case 500:
                vm.$Message.warning({
                    content: res.data.detailMsg || res.data.message || res.data.msg,
                    duration: 3
                })
                break
            case 403:
                vm.$Message.warning({
                    content: res.data.detailMsg || res.data.message || res.data.msg,
                    duration: 3
                })
                break
            case 444:
                vm.$Message.warning({
                    content: res.data.detailMsg || res.data.message || res.data.msg,
                    duration: 3
                })
                return {}
            default:
                return res
        }
    },
    function (error) {
        // Do something with response error
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    if (vm.$route.name !== 'login') {
                        vm.$Message.warning({
                            content: '身份认证信息已失效，请重新登录。',
                            duration: 2,
                            onClose: () => {
                                vm.$router.push({name: 'login'})
                            }
                        })
                    } else {
                        return Promise.reject(error)
                    }
                    break
                case 500:
                    vm.$Message.warning({
                        content: error.response.data.message,
                        duration: 3
                    })
                    break
                case 403:
                    vm.$Message.warning({
                        content: error.response.data.message,
                        duration: 3
                    })
                    break
                case 444:
                    vm.$Message.warning({
                        content: error.response.data.msg,
                        duration: 3
                    })
                    return Promise.reject(error)
                default:
                    return Promise.reject(error)
            }
        } else if (error.message) {
            if (error.message === 'Network Error') {
                vm.$Message.error('网络连接错误，请检查网络环境！')
            } else if (error.message.indexOf('timeout') >= 0) {
                console.log(error)
                vm.$Message.error('网络连接超时，请重试！')
            } else {
                vm.$Message.error(error.message)
            }
        } else {
            vm.$Message.error('知识盲区的错误，联系程序员小哥哥吧！')
        }
    }
)

/**
 * 将请求参数转换为URLSearchParams格式
 * post、put等，axios默认使用json格式，如果需要使用form格式的，调用该函数进行转换
 * data: object
 */
util.formUrlencoded = function (data) {
    return qs.stringify(data)
}

// 定位新打开的页面在pageOpenedList中位置
util.indexOfCurrentPageOpened = function (name, pageOpenedList) {
    for (let index = 0; index < pageOpenedList.length; index++) {
        if (pageOpenedList[index].name === name) {
            return index
        }
    }
    return -1
}

// 初始化header中的面包屑路径
util.initCurrentPath = function (route, routesTree) {
    if (!(routesTree instanceof Array) || routesTree.length === 0) {
        return []
    }
    if (route.name === 'home') {
        return []
    }
    let res = []
    for (let item of routesTree) {
        if (item.children && item.children.length > 0) {
            const temp = getPathOfChild(route, item.children)
            if (temp.done) {
                res = temp.value
                if (item.type === 'menu') {
                    res.splice(0, 0, item.title)
                }
                break
            }
        }
    }
    return res
}

function getPathOfChild(route, sourceArr) {
    let res = {value: [], done: false}
    if (!(sourceArr instanceof Array) || sourceArr.length === 0) {
        return res
    }
    const name = route.name
    for (let item of sourceArr) {
        const temp = []
        temp.push(item.title)
        if (name === item.name) {
            return {value: temp, done: true}
        } else {
            if (item.children && item.children.length > 0) {
                const tempRes = getPathOfChild(route, item.children)
                if (tempRes.done) {
                    return {value: temp.concat(tempRes.value), done: true}
                }
            }
        }
    }
    return res
}

// 数据加密方法
const rsaPubKey =
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC0Jr1NzVUQMburkZT6Rkt0eaPmH8TN6E258l2tZMJgVCP/sL4oKjroKYmNPBkSSiLKFr9wwJqfesMeef6ChGRUXjG6DX0oxQRe0f5/UnyEm/NicJwz9xwkU34gbuo1VB/EA2QZ5dl1rj9iSsiqKLK6/QFlVuzslRdAXYZC79vprwIDAQAB'
util.encryptPassword = function (str) {
    if (rsaPubKey) {
        // 对密码进行加密
        let encryptor = new JSEncrypt() // 新建JSEncrypt对象
        encryptor.setPublicKey(rsaPubKey) // 设置公钥
        return encryptor.encrypt(str) // 加密
    } else {
        return str
    }
}

util.getMenuList = function (menus) {
    const tempList = []
    menus.forEach((ele) => {
        if (ele.type && ele.type === 'menu') {
            const tempObj = {}
            if (ele.children) {
                tempObj.children = util.getMenuList(ele.children)
            }
            tempObj.name = ele.name
            tempObj.icon = ele.icon || 'ios-cube-outline'
            tempObj.title = ele.title
            tempList.push(tempObj)
        }
    })
    return tempList
}

util.getMenuRoutes = function (tree) {
    const menuRoutes = buildMenuRoutesStep1(tree)
    buildMenuRoutesStep2(menuRoutes)
    buildMenuRoutesStep3(menuRoutes)
    return menuRoutes
}

function buildMenuRoutesStep1(menus) {
    const tempRoutes = []
    menus.forEach((ele) => {
        const tempObj = {}
        if (ele.children) {
            tempObj.children = buildMenuRoutesStep1(ele.children)
        }
        tempObj.path = ele.path
        tempObj.name = ele.name
        tempObj.meta = {
            title: ele.title,
            ...ele.meta
        }
        tempObj.component = ele.component
        tempRoutes.push(tempObj)
    })
    return tempRoutes
}

function buildMenuRoutesStep2(routes, root) {
    routes.forEach((ele) => {
        if (ele.children) {
            // rootEle保存根节点对象
            const rootEle = root || ele
            buildMenuRoutesStep2(ele.children, rootEle)
            if (JSON.stringify(ele) !== JSON.stringify(rootEle)) {
                if (!ele.component) {
                    ele.children.forEach((item) => {
                        // 将二级菜单的信息放入子路由中
                        item.meta.parentName = ele.name
                    })
                }
                rootEle.children = rootEle.children.concat(ele.children)
                delete ele.children
            }
        }
    })
}

function buildMenuRoutesStep3(routes) {
    routes.forEach((ele, index) => {
        if (ele.children) {
            buildMenuRoutesStep3(ele.children)
        }
        if (!ele.component) {
            routes.splice(index, 1)
        }
    })
}

function loadConfigs() {

    Object.keys(window).forEach((key) => {
        if (key.startsWith('$')) {
            if (window[key]) {
                util[key.slice(1)] = window[key]
            }
            delete window[key]
        }
    })
}


// 数据合并
export function mergeRecursive(source, target) {
    for (var p in target) {
        try {
            if (target[p].constructor == Object) {
                source[p] = mergeRecursive(source[p], target[p])
            } else {
                source[p] = target[p]
            }
        } catch (e) {
            source[p] = target[p]
        }
    }
    return source
};

// 回显数据字典
export function selectDictLabel(datas, value) {
    if (value === undefined) {
        return ''
    }
    var actions = []
    Object.keys(datas).some((key) => {
        if (datas[key].value == ('' + value)) {
            actions.push(datas[key].label)
            return true
        }
    })
    if (actions.length === 0) {
        actions.push(value)
    }
    return actions.join('')
}

export default util


// file转成base64图片
export function changeImageByBase64(file, callback) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = function () {
        callback(this.result);
    };
}


export function jsonToFormData(json) {
    const formData = new FormData();

    /**
     * 递归地将 JSON 数据添加到 FormData 中
     * @param {*} data - 当前处理的数据
     * @param {string} parentKey - 父级键名（用于嵌套对象）
     */
    function appendFormData(data, parentKey = '') {
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            // 如果是对象或数组，递归处理
            Object.keys(data).forEach(key => {
                appendFormData(data[key], parentKey ? `${parentKey}[${key}]` : key);
            });
        } else {
            // 基本类型值直接添加到 FormData
            formData.append(parentKey, data);
        }
    }

    appendFormData(json);
    return formData;
}